import Footer from "../../Footer"
import Navbar from "../../Navbar"
import { useLocation } from "react-router-dom";
import CostingTable from "./CostingTable";
import ActualCostingTable from "./ActualCostingTable";

const CostingAnalysis = () => {
    const location = useLocation();

    const { state } = location;
    const costingAnalysisData = state?.reportDetails;

    const reports = costingAnalysisData?.fnb_costing_reports || [];

    const foodData = reports.find(r => r.report_for === "Food") || {};
    const beverageData = reports.find(r => r.report_for === "Beverage") || {};

    const toNumber = (val) => parseFloat(val) || 0;

    const calculatePercentage = (part, total) => {
        if (!total || total === 0) return null;
        return ((Math.abs(part) / total) * 100).toFixed(2);
    };

    const actualFoodAccuracy = (Number(foodData?.cost_of_goods_sold) / Number(foodData?.sales_summary?.net_sale) * 100).toFixed(2)

    const actualBeverageAccuracy = (Number(beverageData?.cost_of_goods_sold) / Number(beverageData?.sales_summary?.net_sale) * 100).toFixed(2);

    const calculateCostAccuracy = (actualPercent, theoreticalPercent) => {
        if (
            actualPercent == null ||
            theoreticalPercent == null ||
            theoreticalPercent === 0
        ) return null;

        return (100 - ((actualPercent - theoreticalPercent) * 100) / theoreticalPercent).toFixed(2);
    };

    const foodCostAccuracy = calculateCostAccuracy(
        Number(actualFoodAccuracy),
        toNumber(foodData.net_cost_percent)
    );

    const beverageCostAccuracy = calculateCostAccuracy(
        Number(actualBeverageAccuracy),
        toNumber(beverageData?.net_cost_percent)
    );

    const formatNumber = (val) => {
        if (val === null || val === undefined) return '0';

        const parsed = parseFloat(val);
        return parsed.toString();
    };

    const formatToMax3Decimals = (value) => {
        if (value === null || value === undefined) return '0';

        const num = Number(value);

        if (Number.isNaN(num)) return '0';

        return parseFloat(num.toFixed(3)).toString();
    };

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />

            <div className="p-2.5 text-xs bg-white text-black">
                <div className="text-base font-semibold mb-2 text-center tracking-wide">
                    Food and Beverage Costing Analysis for {costingAnalysisData.outlet} {" "}
                    <span className="text-sm font-normal">
                        (From <span className="font-semibold">{costingAnalysisData.start_date}</span> To <span className="font-semibold">{costingAnalysisData.end_date}</span>)
                    </span>
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                    <CostingTable
                        data={foodData}
                        type="Food"
                        calculatePercentage={calculatePercentage}
                        formatNumber={formatNumber}
                    />

                    <CostingTable
                        data={beverageData}
                        type="Beverage"
                        calculatePercentage={calculatePercentage}
                        formatNumber={formatNumber}
                    />

                    <ActualCostingTable
                        data={foodData}
                        type="Food"
                        actualAccuracy={actualFoodAccuracy}
                        costAccuracy={foodCostAccuracy}
                        formatNumber={formatToMax3Decimals}
                        otherCost={costingAnalysisData?.other_cost_food}
                    />

                    <ActualCostingTable
                        data={beverageData}
                        type="Beverage"
                        actualAccuracy={actualBeverageAccuracy}
                        costAccuracy={beverageCostAccuracy}
                        formatNumber={formatToMax3Decimals}
                        otherCost={costingAnalysisData?.other_cost_beverage}
                    />
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default CostingAnalysis